import React from 'react';
import { connect } from 'react-redux';
import { FilesIcon } from 'src/components/Icons';
import useLgpdSignature from './hooks/useLgpdSignature';
import {
  MODAL_TITLE,
  LGPD_TYPE_LABEL,
  buildAcceptText,
  buildRejectText,
} from './constants';
import * as Ui from './styles';

/**
 * Modal bloqueante de assinatura dos documentos LGPD.
 *
 * Renderizada sobre o Dashboard: enquanto `needSignDocuments` for verdadeiro e os
 * documentos pendentes tiverem sido carregados, o overlay do `Modal` impede a
 * interação com o restante da aplicação. Portado do analyze-font-ia (TEN-2657);
 * as referências "doc §" apontam para o `docs/lgpd-analyze-flow.md` de lá.
 */
function LgpdSignature({ needSignDocuments, dispatch }) {
  const {
    documents,
    isSigning,
    mode,
    onConfirm,
    onDiscord,
    onRejectCancel,
    onRejectConfirm,
  } = useLgpdSignature(needSignDocuments, dispatch);

  // Só abre após carregar os documentos pendentes (evita modal sem conteúdo)
  const isOpen = needSignDocuments && documents.length > 0;
  if (!isOpen) return null;

  const types = documents.map((doc) => doc.type);
  const isRejectMode = mode === 'reject';

  const body = isRejectMode ? (
    <Ui.Content>
      <Ui.Text>{buildRejectText(types)}</Ui.Text>
    </Ui.Content>
  ) : (
    <Ui.Content>
      <Ui.Text>{buildAcceptText(types)}</Ui.Text>
      <Ui.Links>
        {documents.map((doc) => (
          <Ui.DocumentLink
            key={doc.id}
            href={doc.location}
            target='_blank'
            rel='noopener noreferrer'
          >
            {LGPD_TYPE_LABEL[doc.type] || doc.nome}
          </Ui.DocumentLink>
        ))}
      </Ui.Links>
    </Ui.Content>
  );

  return (
    <Ui.LgpdModal
      isOpen={isOpen}
      title={MODAL_TITLE}
      iconComponent={<FilesIcon />}
      okBtnTitle={isRejectMode ? 'Rejeitar' : 'Concordo'}
      cancelBtnTitle={isRejectMode ? 'Cancelar' : 'Discordo'}
      isLoading={isSigning}
      onOk={isRejectMode ? onRejectConfirm : onConfirm}
      onCancel={isRejectMode ? onRejectCancel : onDiscord}
      width='500px'
      contentHeight='auto'
      btnPosition='flex-end'
    >
      {body}
    </Ui.LgpdModal>
  );
}

const mapStateToProps = (state) => ({
  needSignDocuments: state.access.needSignDocuments,
});

export default connect(mapStateToProps)(LgpdSignature);
